
class CustomSelect extends HTMLElement {
    constructor() {
        super();

        this.bindEvents = this.bindEvents.bind(this);
        this.toggleCustomSelect = this.toggleCustomSelect.bind(this);
    }

    connectedCallback() {
        this.CustomSelectEl = this;
        this.selectItems = this.querySelectorAll('li');
        this.selectOpener = this.querySelector('.current');

        this.bindEvents();
        this.getLargerItem();
    }

    bindEvents() {
        if(this.selectOpener) {
            this.selectOpener.addEventListener('click', this.toggleCustomSelect)
        }
    }

    getLargerItem() {
        let maxWidth = 0;
        this.selectItems.forEach(item => {
            maxWidth = Math.max(maxWidth, item.offsetWidth);  
        });
        this.CustomSelectEl.style.setProperty('--custom-select-width', `${maxWidth}px`);
    }

    toggleCustomSelect() {
        this.CustomSelectEl.classList.toggle('active');
    }
}

customElements.define('w3-select', CustomSelect);
